import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PlusCircle } from '../../icons';
export const menuFooterItemsFromOptions = (param)=>{
    let { newItemOptions, promotionalAction, testIds, runNewItemOption, runPromotionalAction } = param;
    return [
        ...newItemOptions.map((option, index)=>{
            var _option_icon;
            return {
                variant: 'contextualAction',
                props: {
                    // WHY: inherent add-new-item action owned by the footer mapper — consumers can't rename it (bi-tracking rule 6a)
                    bi: {
                        name: 'add_new_item'
                    },
                    testId: testIds.newItemOption(index),
                    title: option.text,
                    icon: (_option_icon = option.icon) !== null && _option_icon !== void 0 ? _option_icon : /*#__PURE__*/ _jsx(PlusCircle, {}),
                    disabled: option.disabled,
                    disabledTooltip: option.disabledTooltip,
                    onMouseDown: ()=>runNewItemOption(option)
                }
            };
        }),
        ...promotionalAction ? [
            {
                variant: 'promotionalAction',
                props: {
                    // WHY: inherent promotional-action owned by the footer mapper — consumers can't rename it (bi-tracking rule 6a)
                    bi: {
                        name: 'promotional_action'
                    },
                    testId: testIds.promotionalAction,
                    title: promotionalAction.title,
                    body: promotionalAction.body,
                    onMouseDown: ()=>runPromotionalAction(promotionalAction)
                }
            }
        ] : []
    ];
};
